<template>
  <div
    v-if="$slots.text"
    class="w-full flex flex-row items-center gap-4 -mb-[4px]"
  >
    <div class="h-0.5 w-full flex-col justify-center items-start inline-flex">
      <div class="w-full h-[1px] bg-black"></div>
      <div class="w-full h-[1px] opacity-80 bg-[#272727]"></div>
    </div>

    <div
      class="flex flex-row items-center gap-1 text-lg font-bold mb-[2px] leading-none whitespace-nowrap"
    >
      <slot name="text" />
      <font-awesome-icon
        v-if="navigationArrow"
        class="text-sm"
        icon="fa-solid fa-chevron-right"
      />
    </div>

    <div class="h-0.5 w-full flex-col justify-center items-start inline-flex">
      <div class="w-full h-[1px] bg-black"></div>
      <div class="w-full h-[1px] opacity-80 bg-[#272727]"></div>
    </div>
  </div>

  <div
    v-else
    style="height: 1px"
    class="w-full flex-col justify-center items-start inline-flex"
  >
    <div style="height: 0.5px" class="w-full bg-black"></div>
    <div style="height: 0.5px" class="w-full opacity-80 bg-[#272727]"></div>
  </div>
</template>

<script setup>
  defineOptions({
    name: "Divider",
  })

  defineProps({
    navigationArrow: {
      type: Boolean,
      default: true,
    },
  })
</script>
